var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M19 13v6h-6v-6h6zm-8 0v6H5v-6h6zm0-8v6H5V5h6zm8 0v6h-6V5h6z","fill":"#53647f","id":"interior","key":1})]);
}

Grid.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Grid;

Grid.default = Grid;
